import { Component, OnInit, Input } from "@angular/core";
import {
  DataService,
  Dialog,
  NotificationService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import {
  BulkUpdatePackageReviewDocument,
  CheckBulkUpdatePackageReviewDocument,
  PackageReviewsQuery,
} from "src/generated-gql/graphql";
import { ProductVariantSelectorComponent } from "../update-sku-dialog/product-variant-selector/product-variant-selector.component";
import { take, combineLatest } from "rxjs";

@Component({
  //selector: "approve-inbound-dialog",f
  templateUrl: "./bulk-update-sku-dialog.component.html",
  standalone: true,
  imports: [SharedModule, ProductVariantSelectorComponent],
})
export class BulkUpdateSkuDialogComponent implements Dialog<boolean>, OnInit {
  resolveWith: (result?: boolean) => void;

  constructor(
    private dataService: DataService,
    private notificationService: NotificationService
  ) {}
  ngOnInit(): void {}

  @Input()
  items: PackageReviewsQuery["packageReviews"]["items"];

  currentVariant: any;

  newVariant: any;

  affectOrders: null | any[] = null;

  addCurrentProductVariant(event: any) {
    if (!event) {
      this.currentVariant = null;
      this.checkBulkUpdate();
      return
    }

    this.dataService.product
      .getProductVariant(event.productVariantId)
      .single$.subscribe((res) => {
        if (res.productVariant) {
          this.currentVariant = res.productVariant;
          this.checkBulkUpdate();
        }
      });
  }
  addNewProductVariant(event: any) {
    if (!event) {
      this.newVariant = null;
      this.checkBulkUpdate();
      return;
    }
    this.dataService.product
      .getProductVariant(event.productVariantId)
      .single$.subscribe((res) => {
        if (res.productVariant) {
          this.newVariant = res.productVariant;
          this.checkBulkUpdate();
        }
      });
  }

  checkBulkUpdate() {
    if (!this.currentVariant || !this.newVariant) {
      this.affectOrders = null;
      return;
    }

    this.dataService
      .mutate(CheckBulkUpdatePackageReviewDocument, {
        input: {
          ids: this.items.map((i) => i.id),
          currentVariantId: this.currentVariant.id,
          newVariantId: this.newVariant.id,
        },
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res.checkBulkUpdate !== null) {
          this.affectOrders = res.checkBulkUpdate!;
        }
      });
  }

  save() {
    console.log(this.currentVariant);

    this.dataService
      .mutate(BulkUpdatePackageReviewDocument, {
        input: {
          ids: this.items.map((i) => i.id),
          currentVariantId: this.currentVariant.id,
          newVariantId: this.newVariant.id,
        },
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res.bulkUpdatePackageReview) {
          this.notificationService.success(
            `Bulk update ${res.bulkUpdatePackageReview.length} items sucessfully`
          );
          this.resolveWith(true);
        }
      });
  }

  cancel() {
    this.resolveWith(false);
  }
}
